import {useMemo} from 'react';

import {useSelector} from 'react-redux';

import {LICENSE} from '@/constants/fieldNames';

const useIsDemoMode = () => {
  const licenseStatus = useSelector((state) => state.deviceInfoStore.licenseStatus);
  const licenseType = useSelector((state) => state.deviceInfoStore.licenseType);

  const isDemoMode = useMemo(() => {
    const isLicenseActive = licenseStatus === LICENSE.STATUS.ACTIVE && licenseType === LICENSE.TYPE.TEMPORARY;
    const isPermanentLicense = licenseType === LICENSE.TYPE.PERMANENT;
    return !(isLicenseActive || isPermanentLicense);
  }, [licenseStatus, licenseType]);

  return isDemoMode;
};
export default useIsDemoMode;
